import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * `cn` — canonical Tailwind className combiner. Used by every shadcn-derived
 * component. Lives in mercato (not shared) because it depends on
 * `tailwind-merge` which is a UI-only dep.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
